import base64 from '../global/base64.js';
import md5 from 'js-md5'

import store from '@/store/index.js';
import timeHelper from '../global/timeHelper.js';
import axios from 'axios';

import global from '../global/global.js'

import {
  Message,
  Loading
} from 'element-ui'; //项目已经全局引入element的话可以不单独引入
let loading
const startLoading = () => { //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0)'
  })
}
const endLoading = () => { //使用Element loading-close 方法
  loading.close()
}

const fSmApiReq = async ({
  sReqUrl,
  methodName,
  sReqJsonStr,
  mchId,
  mallId,
  userId,
  signType = 'TOKEN',
  reqToken,
  sOrgAk,
  sOrgSk,
}) => {
  // 每次调用API时都重新获取最新的objByPayAdmin数据
  let objByPayAdmin = global.fGetByPayAdmin();
  console.log(objByPayAdmin)
  let reqTime = timeHelper.fGetNowTime(2);
  // 请求参数BASE64
  let reqJson = Base64.encode(sReqJsonStr);
  let js = {};

  js['METHOD_NAME'] = methodName || '';
  js['REQ_JSON'] = reqJson;
  js['MCH_ID'] = userId || objByPayAdmin.orgUserInfo.userId || '1001';
  js['USER_ID'] = userId || objByPayAdmin.orgUserInfo.userId || '1001';
  js['APP_NAME'] = 'smPayAdmin'
  js['REQ_FROM'] = 'WEB';
  js['REQ_VER'] = 'smPayAdmin20260108';
  js['REQ_TIME'] = reqTime;
  js['SIGN_TYPE'] = signType || 'TOKEN';
  js['REQ_LNG'] = 'zh-CN'



  // 组装签名
  if (signType == 'MD5') {
    let sSign
    sSign = sOrgAk + reqJson + reqTime + sOrgSk;
    sSign = md5(sSign);
    sSign = sSign.toLowerCase();
    js['ORG_AK'] = sOrgAk
    js['REQ_SIGN'] = sSign
  } else {
    console.log( reqToken )
    console.log( objByPayAdmin.orgUserInfo.mainToken)
    js['REQ_TOKEN'] = reqToken || objByPayAdmin.orgUserInfo.mainToken || 'token';

  }
  // if (api.smCom.fSmIsEmpty(reqToken || smPayAdmin.djsAdminToken)) {
  //   window.location.href = '/'
  // }
  try {
    startLoading()
    let res = await axios.post(sReqUrl, js);
    endLoading()
    console.log('Received response:', res.data); // 请求后的日志记录
    if (!isObject(res.data)) {
      return {
        result: 'fail',
        msg: res.data
      }
    }
    if (res.data.result != 'sucess' && res.data.sub_msg == 'tokenFail') {
      setTimeout(() => {
           window.location.replace('https://www.sanmipos.com/smpay/partnerAdmin/#/login')
      }, 2000)
      return {
        result: 'fail',
        msg: '登录超时 请重新登陆'
      }
    }

    return res.data;
  } catch (error) {
    endLoading()
    console.error('Error in API request:', error); // 记录错误日志
    return {
      result: 'fail',
      msg: error.message
    }
    // throw error.message; // 或者返回一个标准的错误对象
  }
  // let res = await axios.post(sReqUrl, js);
  // console.log(res.data)

};
// {"result":"fail","msg":"Cannot create file "D:\smSrv\srv\sys\eLabelTpl\mchTpl\sysTpl-eP2-1-SC-20241228135912397R666.html". 系统找不到指定的路径。","sub_msg":"COPY_LIB"}
function isObject(obj) {
  return typeof obj === 'object' && obj !== null;
}

//主服务器接口
const fSmPayAdminApi = async (obj) => {
  console.log(obj, 'fSmCloudAdminApi')
  let sReqUrl;
  sReqUrl = global.smPayAdmin.sys.mainSrvUrl + '/smApi/smPayMain/smPayAdmin/adminApi/'
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: obj.mchId,
    userId: obj.userId,
    sApiRandomStr: obj.sApiRandomStr,
    signType: obj.signType,
    sOrgAk: obj.sOrgAk,
    sOrgSk: obj.sOrgSk,
  });
};

const fSmPayQueryApi = async (obj) => {
  console.log(obj, 'fSmCloudQueryApi')
  // obj.js.DSP_CA = 'WIN'
  let sReqUrl = global.smPayAdmin.sys.mainSrvUrl + '/smApi/smPayMain/smPayQuery/queryApi';
  return fSmApiReq({
    sReqUrl,
    methodName: obj.methodName,
    sReqJsonStr: JSON.stringify(obj.js),
    mchId: obj.mchId,
    userId: obj.userId,
    sApiRandomStr: obj.sApiRandomStr,
    signType: obj.signType,
    sOrgAk: obj.sOrgAk,
    sOrgSk: obj.sOrgSk
  });
}


export default {
  fSmPayAdminApi,
  fSmPayQueryApi

}



// WEBPACK FOOTER //
// ./src/common/requset/smPayMainApi.js